"use client";

import { useEffect } from "react";
import { SessionProvider, useSession } from "next-auth/react";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n/context";
import { CookieConsentBanner } from "@/components/consent/CookieConsent";
import type { Language } from "@/lib/i18n";
import posthog from "posthog-js";

function PostHogIdentify() {
  const { data: session } = useSession();
  useEffect(() => {
    if (session?.user?.id) {
      posthog.identify(session.user.id, {
        name: session.user.name ?? undefined,
      });
    }
  }, [session?.user?.id, session?.user?.name]);
  return null;
}

export function Providers({ children, language }: { children: React.ReactNode; language?: Language }) {
  return (
    <SessionProvider>
      <PostHogIdentify />
      {/* Default to LIGHT regardless of system preference — the brand is
         the cream "paper" surface, and the system-dark fallback was making
         mobile look near-black. `enableSystem` is on so the explicit "System"
         option (ThemeToggle + footer controls) follows the device, but the
         default stays light for users who never choose. */}
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem disableTransitionOnChange>
        <I18nProvider initialLanguage={language}>
          {children}
          <CookieConsentBanner />
          <Toaster />
        </I18nProvider>
      </ThemeProvider>
    </SessionProvider>
  );
}
